export const CARCODE_CONFIG = {
  leadTags: '',
  skipButton: true,
  skipDraggable: true,
  skipSdkButtons: true,
  alwaysOpenForm: false,
  skipMobileApp: true,
  useGlobalCalloutStatus: true,
  skipPiiForm: false,
  phoneNumberPolicy: 'edmunds-first',
  disableGoogleAnalytics: true,
  disableEdwAnalytics: true,
  disableGtmAnalytics: false,
};

export const CALL_TAB_ID = 'call';
export const EMAIL_TAB_ID = 'email';
export const CHAT_TAB_ID = 'chat';
export const TEXT_TAB_ID = 'text';
export const MESSENGER_TAB_ID = 'messenger';
export const TABS = [
  {
    tabId: EMAIL_TAB_ID,
    classes: 'rounded-start',
    onClickHandler: 'openEmailForm',
    icon: 'icon-envelop3',
    title: 'Email',
  },
  {
    tabId: CHAT_TAB_ID,
    onClickHandler: 'openChat',
    icon: 'icon-bubbles5',
    title: 'Chat',
  },
  {
    tabId: TEXT_TAB_ID,
    onClickHandler: 'openText',
    icon: 'icon-mobile',
    title: 'Text',
  },
  {
    tabId: MESSENGER_TAB_ID,
    onClickHandler: 'openFacebook',
    icon: 'icon-MessengerIcon',
    title: 'Messenger',
  },
];
export const TABS_MOBILE = [
  {
    tabId: CALL_TAB_ID,
    icon: 'icon-phone2',
    onClickHandler: 'firePhoneTracking',
    title: 'Call',
  },
  {
    tabId: TEXT_TAB_ID,
    onClickHandler: 'openText',
    icon: 'icon-mobile',
    title: 'Text',
  },
  {
    tabId: CHAT_TAB_ID,
    onClickHandler: 'openChat',
    icon: 'icon-bubbles5',
    title: 'Chat',
  },
  {
    tabId: MESSENGER_TAB_ID,
    onClickHandler: 'openFacebook',
    icon: 'icon-MessengerIcon',
    title: 'Messenger',
  },
];
